/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Story_TitleInputs */

const en_about_story_title = /** @type {(inputs: About_Story_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Story`)
};

const de_about_story_title = /** @type {(inputs: About_Story_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsere Geschichte`)
};

const fr_about_story_title = /** @type {(inputs: About_Story_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Story`)
};

const es_about_story_title = /** @type {(inputs: About_Story_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Story`)
};

const it_about_story_title = /** @type {(inputs: About_Story_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Story`)
};

const nl_about_story_title = /** @type {(inputs: About_Story_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Story`)
};

const pl_about_story_title = /** @type {(inputs: About_Story_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Story`)
};

const fi_about_story_title = /** @type {(inputs: About_Story_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Story`)
};

const da_about_story_title = /** @type {(inputs: About_Story_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Story`)
};

const sv_about_story_title = /** @type {(inputs: About_Story_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Story`)
};

/**
* | output |
* | --- |
* | "Our Story" |
*
* @param {About_Story_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_story_title = /** @type {((inputs?: About_Story_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Story_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_story_title(inputs)
	if (locale === "fr") return fr_about_story_title(inputs)
	if (locale === "es") return es_about_story_title(inputs)
	if (locale === "it") return it_about_story_title(inputs)
	if (locale === "nl") return nl_about_story_title(inputs)
	if (locale === "pl") return pl_about_story_title(inputs)
	if (locale === "fi") return fi_about_story_title(inputs)
	if (locale === "da") return da_about_story_title(inputs)
	if (locale === "sv") return sv_about_story_title(inputs)
	return en_about_story_title(inputs)
});